var path = './dashboard/title_bar.html';
var html = "<div id=\"analytics-title-bar\">\n    <div class=\"title\">\n        {{'ANALYTICS.DASHBOARD.TITLE'|translate}} <span class=\"beta-flag\">{{'GENERAL_LABELS.BETA_FEATURE_TEXT'|translate}}</span>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;